module.exports = __webpack_public_path__ + "media/images/lb/612-d350631ccf89823090384d7c873a1361.svg";